import React from 'react';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
    state = { hasError: false, error: null, errorInfo: null };
    static getDerivedStateFromError(error) { return { hasError: true, error }; }
    componentDidCatch(error, errorInfo) { console.error("ErrorBoundary caught an error:", error, errorInfo); this.setState({ errorInfo }); }
    render() {
        const { t } = this.props;
        if (this.state.hasError) return (<div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-red-100 to-orange-100 text-red-800 p-4"><h2 className="text-3xl font-bold mb-4">{t('errorBoundary.title')}</h2><p className="text-lg text-center mb-4">{t('errorBoundary.description')}</p>{this.props.showDetails && (<details className="mt-4 p-4 bg-red-50 rounded-lg text-sm text-left max-w-lg overflow-auto"><summary className="font-semibold cursor-pointer">{t('errorBoundary.details')}</summary><pre className="mt-2 whitespace-pre-wrap break-all">{this.state.error && this.state.error.toString()}<br />{this.state.errorInfo && this.state.errorInfo.componentStack}</pre></details>)}</div>);
        return this.props.children;
    }
}

export default withTranslation()(ErrorBoundary);